import React, {useState} from 'react'
import { Button, Modal, Row, Col, Form, Alert, Card } from 'react-bootstrap'
import { documentationTaskService, suggestionListService } from '../../../_services'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from "react-i18next"
import { v4 as uuidv4 } from 'uuid'
import { GoogleMap, Marker, Polygon } from '@react-google-maps/api'

function EditTaskButton(props) {

	const [state, setState] = useState(props.data)
	const [addContactPersonState, setAddContactPersonState] = useState({})
	const [suggestionList, setSuggestionList] = useState(null)
	const [validated, setValidated] = useState(false)
	const [addContactPersonValidated, setAddContactPersonValidated] = useState(false)
    const [show, setShow] = useState(false)
    const [showAddContactPerson, setShowAddContactPerson] = useState(false)
    const {t} = useTranslation('common')

    const onClick = () => {
        setState(props.data)
        setValidated(false)
        setShow(true)
        setShowAddContactPerson(false)

		var type = props.data.type
        if (type == "SINGLE_CHOICE_SUGGESTION" || type == "MULTI_CHOICE_SUGGESTION" || type == "CONTACT_PERSONS") {
            suggestionListService.get(props.data.options).then(data => {
	            setSuggestionList(data)
	        })
        }
    }

    const handleSubmit = (event) => {
	    event.preventDefault()
	    const form = event.currentTarget
	    if (form.checkValidity() === false) {
	        event.stopPropagation()
	        setValidated(true)
	    } else {
	        handleConfirm()
			setValidated(false)
	    }
	}

	const handleAddContactPersonSubmit = (event) => {
		console.log('handleAddContactPersonSubmit')
	    event.preventDefault()
	    const form = event.currentTarget
	    if (form.checkValidity() === false) {
	        event.stopPropagation()
	        setAddContactPersonValidated(true)
	    } else {
			var answerArray = []
			suggestionList.params.columns.split(";").forEach(column => {
				var value = addContactPersonState[column] || ''
				answerArray.push(value)
			})
			var newContactPerson = answerArray.join(';')

			if (!state.answer.includes(newContactPerson)) {
				var newAnswer = state.answer
				if (newAnswer) {
					newAnswer += '\n'
				}
				newAnswer += newContactPerson

				setState( prevState => ({
			        ...prevState,
			        answer: newAnswer
			    }))

				setAddContactPersonState({})
				//setShowAddContactPerson(false)

				setAddContactPersonValidated(false)
			}
	    }
	}

	const handleConfirm = () => {
        handleClose()

        var newState = {
            id: state.id,
            answer: state.answer
        }

        documentationTaskService.update(newState.id, newState).then(result => {
            props.onUpdate(result)
        })
    }

    const handleClose = () => {
		setShow(false)
		document.body.className = ""
		document.body.style = '';
    }

    const handleChange = (e) => {
	    const target = e.target
	    const name = target.name
	    var value = target.value

	    if (state.type == 'MULTI_CHOICE' || state.type == 'MULTI_CHOICE_SUGGESTION') {
			var answers = state.answer ? state.answer.split(';') : []

			if (target.checked) {
				answers.push(target.name)
			} else {
				answers = answers.filter(answer => answer != target.name)
			}

			value = answers.join(';')
	    } else if (state.type == 'CONTACT_PERSONS') {
			var answers = state.answer ? state.answer.split('\n') : []

			if (target.checked) {
				answers.push(target.name)
			} else {
				answers = answers.filter(answer => answer != target.name)
			}

			answers.sort()

			value = answers.join('\n')
	    } else if (target.type === 'checkbox') {
	        value = target.checked ? state.options : ''
	    } else if (state.type == 'DATE_RANGE') {
	        var split = state.answer.split(';')
	        if (target.name == 'date1') {
	            value = value + ";" + split[1]
	        } else if (target.name == 'date2') {
	            value = split[0] + ";" + value
	        }
	    } else if (state.type == 'DATE_TIME') {
	        var split = state.answer.split(' ')
	        if (target.name == 'date') {
	            value = value + " " + split[1]
	        } else if (target.name == 'time') {
	            value = split[0] + " " + value
	        }
	    }

	    setState( prevState => ({
	        ...prevState,
	        answer: value
	    }))
	}

	const handleAddContactPersonChange = (e) => {
	    const target = e.target
	    const name = target.name
	    var value = target.value

	    var newAddContactPersonState = {...addContactPersonState}
	    newAddContactPersonState[name] = value

	    setAddContactPersonState(newAddContactPersonState)
	}

	const getContactPersonsSuggestions = suggestionList => {
		var suggestions = suggestionList.suggestions
		if (state.answer) {
			var answers = state.answer.split('\n')
			answers.forEach(answer => {
				if (!suggestions.some(suggestion => suggestion.text == answer)) {
					var suggestion = {
						id: uuidv4(),
						text: answer
					}
					suggestions.push(suggestion)
				}
			})
		}
		return suggestions
	}

	const addContactPerson = () => {
		setShowAddContactPerson(true)
	}

	const cancelAddContactPerson = () => {
		setAddContactPersonValidated(false)
		setAddContactPersonState({})
		setShowAddContactPerson(false)
	}

	const onMapLoad = map => {
        console.log('onMapLoad')

		map.setZoom(5)
		map.setCenter({ lat: 62.5, lng: 17.5 })

		var latLngs = getLatLngs()
		if (latLngs) {
			if (latLngs.length == 1) {
				map.setZoom(8)
				map.setCenter(latLngs[0])
			} else {
				const bounds = new window.google.maps.LatLngBounds()
				latLngs.forEach(latLng => {
					bounds.extend(latLng)
				})
				map.fitBounds(bounds)
			}
		}
    }

	const onMapClick = e => {
		console.log('onClick')

		var latLng = e.latLng.lat() + ";" + e.latLng.lng()
		var answer = state.answer

		switch (state.type) {
			case 'MAP_MARKER':
				answer = e.latLng.lat() + ";" + e.latLng.lng()
				break
			case 'MAP_MULTIPLE_MARKERS':
			case 'MAP_POLYGON':
				if (answer) {
					answer += "\n"
				}
				answer += e.latLng.lat() + ";" + e.latLng.lng()
				break
		}

		setState( prevState => ({
	        ...prevState,
	        answer: answer
	    }))
	}

	const onMarkerClick = e => {
		var latLngs = getLatLngs()
		var newLatLngs = latLngs.filter(latLng => latLng.lat != e.latLng.lat() || latLng.lng != e.latLng.lng())
		var newAnswer = newLatLngs.map(latLng => latLng.lat + ";" + latLng.lng).join("\n")

		setState( prevState => ({
	        ...prevState,
	        answer: newAnswer
	    }))
	}

	const onDragEnd = (e, latLng) => {
		var latLngs = getLatLngs()
		latLngs.forEach(otherLatLng => {
			if (otherLatLng.lat == latLng.lat && otherLatLng.lng == latLng.lng) {
				otherLatLng.lat = e.latLng.lat()
				otherLatLng.lng = e.latLng.lng()
			}
		})
		var newAnswer = latLngs.map(latLng => latLng.lat + ";" + latLng.lng).join("\n")

		setState( prevState => ({
	        ...prevState,
	        answer: newAnswer
	    }))
	}

	const getLatLngs = () => {
		var result = []
		var rows = state.answer.split("\n")
		rows.forEach(row => {
			result.push({
				lat: parseFloat(row.split(";")[0]),
				lng: parseFloat(row.split(";")[1])
			})
		})
		return result
	}

    return (
        <>
	        <Button
	            onClick={onClick}
	            title={t('crudtable.edit')}
	            size="sm"
	            color="info"
	            variant="outline-danger">
	            <FontAwesomeIcon icon={faEdit}/>
	        </Button>
	        <Modal
				style={{overflow: 'scroll'}}
				size={['CONTACT_PERSONS', 'MAP_MARKER', 'MAP_MULTIPLE_MARKERS', 'MAP_POLYGON'].includes(state.type) ? 'lg' : 'md'}
				show={show}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={handleClose}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>{t('documentation.editanswer')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{ props.documentation.status == 'DOWNLOADED' &&
						<Alert variant="danger">
							{t('task.downloadedwarning')}
			            </Alert>
					}
					<Form id="data-form" noValidate onSubmit={handleSubmit} validated={validated}>
						<label>
							{ state.name } { state.required == 'YES' ? '*' : '' }
						</label>
						<br/>
						<i>{state.description}</i>
						{ (state.type == 'TEXT' || state.type == 'PREDEFINED' || state.type == 'ZEBRA_SCANNER') &&
							<Form.Group controlId="answer">
				                <Form.Control
				                    type="text"
				                    name="answer"
				                    value={state.answer || ''}
				                    onChange={handleChange}
				                    required={state.required == 'YES'}
				                />
				            </Form.Group>
						}
						{ state.type == 'CHECKBOX' &&
			                <Form.Label>
		                        <Form.Check
		                            id={state.id}
		                            type="checkbox"
		                            name="answer"
		                            label={state.options}
		                            checked={state.answer}
		                            onChange={handleChange}
		                            required={state.required == 'YES'}
		                        />
		                    </Form.Label>
						}
						{ state.type == 'SINGLE_CHOICE' &&
							<Form.Group controlId="answer">
				                <Form.Control
			                        as="select"
			                        name="answer"
			                        value={state.answer}
			                        onChange={handleChange}
			                        required={state.required == 'YES'}
			                    >
			                        <option value="">Välj svar</option>
			                        { state.options.split(";").map(option => {
			                            return <option key={option} value={option}>{option}</option>
			                        })}
				                </Form.Control>
				            </Form.Group>
						}
						{ state.type == 'MULTI_CHOICE' &&
			                <>
			                    { state.options.split(";").map(option => {
			                        return <div key={option}>
			                            <Form.Label>
					                        <Form.Check
					                            id={state.id + option}
					                            type="checkbox"
					                            name={option}
					                            label={option}
					                            checked={state.answer && state.answer.split(';').includes(option)}
					                            onChange={handleChange}
					                            required={state.required == 'YES' && !state.answer}
					                        />
					                    </Form.Label>
				                    </div>
			                    })}
			                </>
						}
						{ state.type == 'INTEGER' &&
							<Form.Group controlId="answer">
				                <Form.Control
				                    type="number"
				                    name="answer"
				                    value={state.answer}
				                    onChange={handleChange}
				                    required={state.required == 'YES'}
				                />
				            </Form.Group>
						}
						{ state.type == 'DECIMAL' &&
							<Form.Group controlId="answer">
				                <Form.Control
				                    type="number"
				                    name="answer"
				                    value={state.answer}
				                    onChange={handleChange}
				                    required={state.required == 'YES'}
				                />
				            </Form.Group>
						}
						{ state.type == 'SINGLE_CHOICE_SUGGESTION' &&
							<Form.Group controlId="answer">
				                <Form.Control
			                        as="select"
			                        name="answer"
			                        value={state.answer}
			                        onChange={handleChange}
			                        required={state.required == 'YES'}
			                    >
			                        <option value="">Välj svar</option>
			                        { suggestionList &&
			                            <>
			                                { suggestionList.suggestions.map(suggestion => {
					                            return <option key={suggestion.id} value={suggestion.text}>{suggestion.text}</option>
					                        })}
			                            </>
			                        }
				                </Form.Control>
				            </Form.Group>
						}
						{ state.type == 'MULTI_CHOICE_SUGGESTION' &&
							<>
								{ suggestionList &&
									<>
					                    { suggestionList.suggestions.map(suggestion => {
					                        return <div key={suggestion.text}>
					                            <Form.Label>
							                        <Form.Check
							                            id={suggestion.text}
							                            type="checkbox"
							                            name={suggestion.text}
							                            label={suggestion.text}
							                            checked={state.answer && state.answer.split(';').includes(suggestion.text)}
							                            onChange={handleChange}
							                        />
							                    </Form.Label>
						                    </div>
					                    })}
				                    </>
			                    }
			                </>
						}
						{ state.type == 'DATE' &&
							<Form.Group controlId="answer">
				                <Form.Control
				                    type="date"
				                    name="answer"
				                    value={state.answer || ''}
				                    onChange={handleChange}
				                    required={state.required == 'YES'}
				                />
				            </Form.Group>
						}
						{ state.type == 'DATE_RANGE' &&
							<Form.Group controlId="answer">
				                <Form.Control
				                    type="date"
				                    name="date1"
				                    value={state.answer ? state.answer.split(";")[0] : ''}
				                    onChange={handleChange}
				                    required={state.required == 'YES'}
				                    style={{ marginBottom: 2 }}
				                    max={state.answer ? state.answer.split(";")[1] : ''}
				                />
				                <Form.Control
				                    type="date"
				                    name="date2"
				                    value={state.answer ? state.answer.split(";")[1] : ''}
				                    onChange={handleChange}
				                    required={state.required == 'YES'}
				                    min={state.answer ? state.answer.split(";")[0] : ''}
				                />
				            </Form.Group>
						}
						{ state.type == 'TIME' &&
							<Form.Group controlId="answer">
				                <Form.Control
				                    type="time"
				                    name="answer"
				                    value={state.answer || ''}
				                    onChange={handleChange}
				                    required={state.required == 'YES'}
				                />
				            </Form.Group>
						}
						{ state.type == 'DATE_TIME' &&
							<Form.Group controlId="answer">
				                <Form.Control
				                    type="date"
				                    name="date"
				                    value={state.answer ? state.answer.split(" ")[0] : ''}
				                    onChange={handleChange}
				                    required={state.required == 'YES'}
				                    style={{ marginBottom: 2 }}
				                />
				                <Form.Control
				                    type="time"
				                    name="time"
				                    value={state.answer ? state.answer.split(" ")[1] : ''}
				                    onChange={handleChange}
				                    required={state.required == 'YES'}
				                />
				            </Form.Group>
						}
						{ state.type == 'CONTACT_PERSONS' &&
							<>
								{ suggestionList &&
									<>
										<table className="table">
											<thead>
												<tr>
													<th></th>
													{ suggestionList.params.columns.split(";").map(column => {
														return <th key={column}>
															{column}
														</th>
													})}
												</tr>
											</thead>
											<tbody>
							                    { getContactPersonsSuggestions(suggestionList).map(suggestion => {
							                        return <tr key={suggestion.id}>
							                            <td>
							                                <Form.Label>
										                        <Form.Check
										                            id={suggestion.text}
										                            type="checkbox"
										                            name={suggestion.text}
										                            checked={state.answer && state.answer.split('\n').includes(suggestion.text)}
										                            onChange={handleChange}
										                        />
										                    </Form.Label>
							                            </td>
						                                { suggestion.text.split(';').map((column, index) => {
						                                    return <td key={index}>
						                                        {column}
						                                    </td>
						                                })}
								                    </tr>
							                    })}
						                    </tbody>
					                    </table>
					                    <Button variant="outline-primary" onClick={addContactPerson} disabled={showAddContactPerson}>
								            {t('documentation.addcontactperson')}
								        </Button>
							        </>
			                    }
			                </>
						}
						{ ['MAP_MARKER', 'MAP_MULTIPLE_MARKERS', 'MAP_POLYGON'].includes(state.type) &&
							<GoogleMap
								onLoad={onMapLoad}
								mapContainerStyle={{width: '100%', height: '500px'}}
						        options={{ minZoom: 3, zoomControl: true, gestureHandling: 'greedy' }}
						        onClick={onMapClick}>
						        { state && state.answer &&
						            <>
						                { getLatLngs().map(latLng => {
						                    return <Marker
						                        key={latLng.lat + "-" + latLng.lng}
							                    position={latLng}
							                    onClick={onMarkerClick}
							                    draggable={true}
							                    onDragEnd={e => onDragEnd(e, latLng)}
							                />
						                })}
							            { state.type == 'MAP_POLYGON' &&
								            <Polygon paths={getLatLngs()}/>
								        }
					                </>
						        }
							</GoogleMap>
						}
		            </Form>
		            { showAddContactPerson &&
			            <Card style={{marginTop: 10}}>
			                <Card.Body>
			                    <Form id="add-contact-person-form" noValidate onSubmit={handleAddContactPersonSubmit} validated={addContactPersonValidated}>
				                    <Row>
				                        { suggestionList.params.columns.split(";").map(column => {
											return <Col key={'input-' + column}>
					                            <Form.Group controlId={column}>
					                                <Form.Label>
					                                    { column }
					                                    { suggestionList.params.requiredColumns.split(";").includes(column) &&
					                                        <span>*</span>
					                                    }
					                                </Form.Label>
									                <Form.Control
									                    type="text"
									                    name={column}
									                    value={addContactPersonState[column] || ''}
									                    onChange={handleAddContactPersonChange}
									                    required={suggestionList.params.requiredColumns.split(";").includes(column)}
									                />
									            </Form.Group>
											</Col>
										})}
				                    </Row>
				                    <Button variant="secondary" onClick={cancelAddContactPerson} style={{marginRight: '0.5rem'}}>
										{t('crudtable.cancel')}
									</Button>
				                    <Button form='add-contact-person-form' type="submit" variant="primary">
										{t('crudtable.add')}
									</Button>
			                    </Form>
			                </Card.Body>
			            </Card>
			        }
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						{t('crudtable.cancel')}
					</Button>
					<Button form='data-form' type="submit" variant="primary">
						{t('crudtable.ok')}
					</Button>
				</Modal.Footer>
			</Modal>
        </>
    )
}

export default EditTaskButton